import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Wisuda from '@/components/Wisuda'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/daftar/:status',
      name: 'Wisuda',
      component: Wisuda
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js